import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useI18n } from "@/contexts/i18n";
import { PartnerBoxWrapper } from "./PartnerBoxWrapper";
import { AdContainer } from "@/ads/components/AdContainer";
import { AdSlotIds } from "@/shared/types";
import { Divider } from "@gemini/ui";
import { useRefsContext } from "@/contexts/ref";
import { useShowAds } from "../../hooks/useShowAds";
export const PartnerBoxCommercial = () => {
    const { t } = useI18n();
    const { PartnerBoxCommercialRef } = useRefsContext();
    const { isAllSlotsLoaded, showSection } = useShowAds();
    const showDivider = isAllSlotsLoaded([
        AdSlotIds.PARTNERBOX_2_COMMERCIAL,
        AdSlotIds.PARTNERBOX_2_COMMERCIAL,
    ]);
    return (_jsx(_Fragment, { children: showSection([
            AdSlotIds.PARTNERBOX_1_COMMERCIAL,
            AdSlotIds.PARTNERBOX_2_COMMERCIAL,
        ]) && (_jsxs(PartnerBoxWrapper, { partnerBoxRef: PartnerBoxCommercialRef, title: t("advertising.partner_services.headline_one"), children: [_jsx(AdContainer, { adSlotId: AdSlotIds.PARTNERBOX_1_COMMERCIAL, width: "100%", height: "min-content" }), showDivider && _jsx(Divider, {}), _jsx(AdContainer, { adSlotId: AdSlotIds.PARTNERBOX_2_COMMERCIAL, width: "100%", height: "min-content" })] })) }));
};
